<div class="progress-bar">
  <div class="progress-bar-inner" [style.width]="(value/maxValue)*100 + '%'"
       [ngClass]="barColor">
  </div>
</div>
